import { render, staticRenderFns } from "./Evaluation.vue?vue&type=template&id=6cb54ab2"
import script from "./Evaluation.vue?vue&type=script&lang=js"
export * from "./Evaluation.vue?vue&type=script&lang=js"
import style0 from "./Evaluation.vue?vue&type=style&index=0&id=6cb54ab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports